// extracted by mini-css-extract-plugin
export var adjacentSlide = "_o7-9";
export var arrowButtonContainer = "_o7-5";
export var arrowButtonIcon = "_o7-6";
export var carouselArrowButton = "_o7-2";
export var carouselElementContainer = "_o7-1";
export var currentSlide = "_o7-8";
export var left = "_o7-3";
export var otherSlide = "_o7-a";
export var productCarouselContainer = "_o7-0";
export var right = "_o7-4";
export var sliderOverflow = "_o7-7";